{
  "category": {
    "createdNewCategory": "إنشاء فئة جديدة",
    "description": "وصف",
    "name": "اسم"
  },
  "datatable": {
    "rowsPerPage": "الصفوف في الصفحة"
  },
  "department": {
    "addDepartment": "إضافة قسم",
    "createdNewDepartment": "إنشاء قسم جديد",
    "createNewDepartment": "إضافة قسم",
    "departmentAdmin": "مسؤول القسم",
    "departmentName": "اسم القسم",
    "edit": "تحرير",
    "institution": "اسم المؤسسة",
    "institutionName": "اسم المؤسسة",
    "searchDepartments": "قسم البحث (الأقسام)",
    "thisFieldIsRequired": "هذا الحقل مطلوب",
    "updatedDepartment": "قسم محدث"
  },
  "form": {
    "canNotEndBeforeParentStarts": "لا يمكن أن تنتهي عندما لم يبدأ الأصل",
    "canNotEndBeforeStart": "لا يمكن أن تنتهي قبل البدء",
    "canNotEndWhenParentEnded": "لا يمكن أن تنتهي عند انتهاء الأصل",
    "canNotStartAfterEnd": "لا يمكن أن تبدأ بعد نهاية",
    "canNotStartBeforeParentStarts": "لا يمكن البدء قبل بدء تشغيل الأصل",
    "canNotStartWhenParentEnded": "لا يمكن أن تبدأ عند انتهاء الأصل",
    "thisFieldIsRequired": "هذا الحقل مطلوب"
  },
  "general": {
    "accessDenied": "تم رفض الوصول",
    "add": "اضافه",
    "back": "عوده",
    "cancel": "إلغاء الأمر",
    "close": "قم بإغلاق",
    "dateAdded": "تاريخ الإضافة",
    "dateUpdated": "تاريخ التحديث",
    "delete": "حذف",
    "edit": "تحرير",
    "endDate": "تاريخ الانتهاء",
    "loading": "تحميل...",
    "name": "اسم",
    "no": "لا",
    "noData": "لا توجد بيانات",
    "ok": "موافق",
    "remove": "ازاله",
    "save": "حفظ",
    "selectAll": "تحديد الكل",
    "startDate": "تاريخ البدء",
    "yes": "نعم"
  },
  "institution": {
    "contact": "الاتصال",
    "createdNewInstitution": "إنشاء مؤسسة جديدة",
    "createNewInstitution": "إضافة مؤسسة",
    "edit": "تحرير",
    "institutionCity": "المدينه",
    "institutionCountry": "البلد",
    "institutionCounty": "مقاطعه",
    "institutionHouse": "المنزل",
    "institutionLanguage": "اللغه",
    "institutionStreet": "الشارع",
    "institutionTimezone": "Timezone",
    "name": "اسم",
    "region": "المنطقه",
    "searchInstitutions": "البحث في المؤسسات (المؤسسات)",
    "street": "الشارع",
    "switch": "التبديل",
    "switchedTo": "تحولت المؤسسات إلى",
    "unableToSwitch": "غير قادر على التبديل",
    "updatedInstitution": "مؤسسة محدثة"
  },
  "menu": {
    "departments": "الادارات",
    "home": "المنزل",
    "institutions": "المؤسسات",
    "procedure": "إجراء",
    "procedures": "الاجراءات",
    "reinviteusers": "إعادة دعوة المستخدمين",
    "scheduling": "جدوله",
    "study": "درس",
    "survey": "الدراسه الاستقصائيه",
    "userGuide": "دليل المستخدم",
    "users": "المستخدمين"
  },
  "procedure": {
    "addNewCategory": "إضافة فئة جديدة",
    "allSteps": "جميع الخطوات",
    "authors": "كاتب",
    "category": "الفئه",
    "createNewStep": "إضافة خطوة",
    "defineFeedback": "تعريف الملاحظات",
    "department": "اداره",
    "description": "وصف",
    "disableProcedure": "تعطيل الإجراء",
    "editProceduresInformation": "تحرير معلومات الإجراء",
    "import": "استيراد",
    "information": "المعلومات",
    "institution": "المؤسسه",
    "language": "اللغه",
    "languagesAvailable": "اللغات المتاحة",
    "media": "وسائط",
    "name": "اسم",
    "owner": "مالك",
    "procedureCategory": "فئة الإجراء",
    "procedureLanguage": "لغة الإجراء",
    "procedureName": "اسم الإجراء",
    "procedureNotFound": "لم يتم العثور على الإجراء",
    "public": "العامه",
    "publicPrivate": "القطاع العام/الخاص",
    "revisionHistory": "تاريخ المراجعة",
    "searchSteps": "خطوة البحث (خطوات)",
    "seeFeedback": "الاطلاع على الملاحظات",
    "statistics": "الاحصاءات",
    "step": "خطوه",
    "stepNr": "Nr",
    "thisFieldIsRequired": "هذه الخانة مطلوبه",
    "unableToLoad": "غير قادر على تحميل الإجراء",
    "viewAs": "عرض ك"
  },
  "procedures": {
    "addProcedure": "إضافة إجراء",
    "category": "الفئه",
    "deleteProcedure": "حذف الإجراء",
    "department": "اداره",
    "filter": "تصفيه",
    "importProcedures": "إجراءات الاستيراد",
    "private": "الخاصه",
    "procedures": "الاجراءات",
    "public": "العامه",
    "publicPrivate": "القطاع العام/الخاص",
    "searchProcedures": "إجراءات البحث",
    "sort": "نوع"
  },
  "question": {
    "added": "إنشاء سؤال جديد",
    "answers": "اجابات",
    "cognitionName": "اسم الإدراك",
    "cognitionType": "نوع الإدراك",
    "details": "تفاصيل",
    "meaning": "معنى",
    "name": "اسم",
    "options": "خيارات",
    "position": "موقف",
    "question": "السؤال",
    "questionType": "نوع السؤال",
    "set": "تعيين",
    "type": "نوع",
    "types": {
      "CHOICE": "اختيار",
      "COGNITION": "الادراك",
      "SCALE": "نطاق"
    },
    "value": "قيمه"
  },
  "step": {
    "addDescription": "إضافة وصف",
    "addParentStep": "إضافة الخطوة الأصل",
    "chooseParentSep": "اختر الخطوة الأصل",
    "chooseStepOption": "اختيار خيار الخطوة",
    "chooseTransitionType": "اختيار نوع الانتقال",
    "chooseType": "اختر النوع",
    "description": "وصف",
    "dropFilesOrClickToUpload": "إسقاط الملفات هنا أو انقر لتحميل",
    "editStep": "تحرير الخطوة",
    "insertMaxValue": "إدراج قيمة MAX",
    "insertMinValue": "إدراج قيمة MIN",
    "insertOption": "إدراج خيار",
    "option": "الخيار",
    "owner": "مالك",
    "parentStep": "الخطوة الأصل",
    "previousStep": "الخطوة السابقة",
    "saveMedia": "حفظ",
    "stepMedia": "وسائط الخطوة",
    "transitionToNextStep": "الانتقال إلى الخطوة التالية",
    "transitionType": "نوع الانتقال",
    "type": "نوع",
    "value": "قيمه",
    "viewInProcedure": "عرض في الإجراء"
  },
  "study": {
    "addStudy": "إضافة دراسة",
    "author": "كاتب",
    "createdNewStudy": "إنشاء دراسة جديدة",
    "deletedStudy": "الدراسة المحذوفة",
    "deleteStudy": "حذف الدراسة",
    "department": "اداره",
    "description": "وصف",
    "duration": "مده",
    "endDate": "تاريخ الانتهاء",
    "name": "اسم",
    "owner": "مالك",
    "permission": {
      "department": "اداره",
      "institution": "المؤسسه",
      "public": "العامه"
    },
    "searchStudy": "البحث عن الدراسات",
    "startDate": "تاريخ البدء",
    "status": "حاله",
    "studyName": "اسم الدراسة",
    "updatedStudy": "دراسة محدثة",
    "visibility": "الرؤيه"
  },
  "survey": {
    "addAssessmentPeriod": "إنشاء فترة فرعية جديدة",
    "added": "إنشاء استطلاع جديد",
    "addNew": "أضافه جديد",
    "addPeriod": "إضافة فترة جديدة",
    "addSurveyPeriod": "إنشاء فترة استطلاع جديدة",
    "allAssessmentPeriods": "جميع فترات التقييم",
    "ASSESSMENT_PERIOD": "فترة التقييم",
    "author": "كاتب",
    "completePreviousPeriods": "هل يتعين على المشارك في الدراسة إكمال فترة (فترات) سابقة لتمكين هذه الفترة؟",
    "createNewPeriod": "إنشاء فترة جديدة",
    "createNewQuestion": "إضافة سؤال",
    "createNewSurvey": "إنشاء استطلاع جديد",
    "duration": "مده",
    "endDate": "تاريخ الانتهاء",
    "key": "مفتاح",
    "name": "اسم",
    "NONE": "اي",
    "period": "الفتره",
    "periodName": "اسم",
    "position": "موقف",
    "question": "السؤال",
    "questionList": "الاسئله",
    "startDate": "تاريخ البدء",
    "SURVEY_PERIOD": "فترة المسح",
    "type": "نوع"
  },
  "user": {
    "accountSettings": "إعدادات الحساب",
    "chooseUserRole": "اختيار دور المستخدم",
    "contact": "الاتصال",
    "contactInformation": "معلومات الاتصال",
    "dateOfBirth": "تاريخ الميلاد",
    "department": "اداره",
    "emails": "البريد الإلكتروني للمستخدم (ق)",
    "emailsDescription": "إدراج 1 أو أكثر من رسائل البريد الإلكتروني مفصولة بفواصل منقوطة. سيتم إرسال الدعوات للتسجيل بدور المستخدم المختار إلى المستخدمين عبر البريد الإلكتروني.",
    "filter": "تصفيه",
    "gender": "الجنسين",
    "institution": "المؤسسه",
    "institutionalAdmin": "مسؤول مؤسسي",
    "institutionAndDepartment": "المؤسسة والإدارة",
    "invite": "دعوه",
    "inviteUsers": "دعوة المستخدمين",
    "logOut": "تسجيل الخروج",
    "noUsersSelected": "لم يتم تحديد مستخدمين",
    "nurse": "ممرض",
    "password": "كلمه المرور",
    "patient": "المريض",
    "reInviteUsers": "إعادة دعوة المستخدمين",
    "resetPassword": "إعادة تعيين كلمة المرور",
    "resetRequestSentTo": "البريد الإلكتروني لراحة كلمة المرور المرسل إلى",
    "searchUsers": "بحث المستخدمين (المستخدمين)",
    "sendResetPasswordEmailTo": "إرسال بريد إلكتروني لإعادة تعيين كلمة المرور إلى",
    "sort": "نوع",
    "subscription": "الاشتراك",
    "thisFieldIsRequired": "هذا الحقل مطلوب",
    "user": "المستخدم",
    "userDetailsUpdated": "تم تحديث تفاصيل المستخدم",
    "userInformation": "معلومات المستخدم",
    "userRole": "دور المستخدم"
  }
}
